import {Component, OnInit} from '@angular/core';
import {AppConfig} from '../app.config';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html'
})

export class AboutComponent implements OnInit {
    public author: any = {};
    public socialWidth: any;
    public socialHeight: any;
    public socialGroup = {};

    constructor() {
        AppConfig.instance.getAllTextBlocks(textblocks => {
            this.author = textblocks['short_about_author'];
        });
        AppConfig.instance.getConfig(link => {
            this.socialGroup = link;
        });
    }

    ngOnInit() {
        if (window.innerWidth < 1441) {
            this.socialWidth = 350;
            this.socialHeight = 450;
        } else {
            this.socialWidth = 450;
            this.socialHeight = 550;
        }
        if (window.innerWidth < 1200) {
            this.socialWidth = 350;
            this.socialHeight = 400;
        }

        if (window.innerWidth < 500) {
            this.socialWidth = 290;
            this.socialHeight = 350;
        }

        delete window['FB'];
        // if (d.getElementById(id)) return;
        (function (d, s, id) {

            let js, fjs = d.getElementsByTagName(s)[0];
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.11&appId=1130700306963493';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            // if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://platform.twitter.com/widgets.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'twitter'));
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/about/about.component.ts